export default __webpack_public_path__ + "static/media/Wu Ming3.103fd945.jpg";